/**
 * GigSafe's OWN program-manager and attestor details, copied from the Retool app's
 * `defaultFormValue` (approved by Philip as constants in code — spec §10.2). These describe
 * GigSafe, never a customer, and are editable form defaults, not fallbacks for missing data.
 *
 * OPEN: the GigSafe EIN is masked in the Retool export ('63230****'), so it is blank and must
 * be typed until Philip supplies it. `attestorJobTitle` is blank for the same reason: Retool's
 * value ("VO Operations & Strategy") is probably a typo for "VP", and an unconfirmed title must
 * not be pre-filled into an attestation sent to US Bank. The Attestor step requires it typed.
 */
export const PROGRAM_MANAGER_DEFAULTS = {
  programManagerIdentificationNumber: '',
  programManagerName: 'Daniel Gerow',
  contactName: 'Daniel Gerow',
  contactEmailAddress: 'daniel@gigsafe.com',
}

export const ATTESTOR_DEFAULTS = {
  attestorFirstName: 'Amanda',
  attestorLastName: 'Tomkins',
  attestorJobTitle: '',
}

export const DEFAULT_COUNTRY = 'US'
